export default __webpack_public_path__ + "static/media/mobile-search.0cecf86f.svg";